// Single source of truth for links into the product, so a domain change is one
// edit rather than a grep across every CTA on the site.
export const APP_URL = 'https://app.statio.dev';
export const SIGNUP_URL = `${APP_URL}/signup`;
export const LOGIN_URL = `${APP_URL}/login`;

/** Statio's own blog: MCP, agent access and how the product works. Prerendered at /blog. */
export const BLOG_PATH = '/blog';

/**
 * The founder's personal blog, Logical Bytes: Go, CI, side projects. Linked
 * from the footer and the blog, not the main nav, so the nav sends readers to
 * Statio's own posts. The UTM tag shows Statio as the referrer in its analytics.
 */
export const FOUNDER_BLOG_URL =
  'https://logicalbytes.dev/?utm_source=statio&utm_medium=referral&utm_campaign=statio-footer';

/**
 * Sign-up link that carries the plan the visitor clicked, so the app can open
 * checkout for it straight after the org is created. The value is the plan
 * name in lower case (developer, team, business); Free gets the plain link.
 */
export function signupForPlan(plan: string): string {
  const slug = plan.toLowerCase();
  return slug === 'free' ? SIGNUP_URL : `${SIGNUP_URL}?plan=${encodeURIComponent(slug)}`;
}

/**
 * Homebrew. Same convention as Pilum (repo SID-Technologies/Homebrew-Pilum →
 * `brew tap sid-technologies/pilum`): repo SID-Technologies/Homebrew-Statio,
 * the mcphub CLI as a formula and the desktop app as a cask. Pilum's homebrew
 * recipe publishes formulas only, so the cask is maintained in the tap by hand
 * (or by a cask step added to Pilum). Change the tap here and every command on
 * the site follows.
 */
export const BREW_TAP = 'sid-technologies/statio';
export const BREW_CLI = `brew install ${BREW_TAP}/mcphub`;
export const BREW_APP = `brew install --cask ${BREW_TAP}/statio`;
